import { ref, onMounted, onBeforeUnmount } from "vue";
import { useTranslationStore } from "@/stores/translations";
import { useRuntimeConfig, useFetch, useNuxtApp } from "#app";

export const useFormDocumentContact = () => {
  const nuxtApp = useNuxtApp();

  const translationStore = useTranslationStore();
  const translate = translationStore.translate;

  const isLoading = ref(false);
  const LoadingTitle = ref("Loading...");
  const formSuccess = ref(false);
  const formTitle = ref(translate("request.shareholders.meeting.documents.form"));
  const formMessage = ref(null);
  const showModal = ref(false);
  const privacyStatement = ref(false);

  // Email validation function
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const submitForm = async (event) => {

    const form = event.target;

    // ✅ VALIDATE CHECKBOX GROUP
    const langs = form.querySelectorAll('input[name="doc_langs[]"]:checked');
    const types = form.querySelectorAll('input[name="doc_types[]"]:checked');

    if (langs.length === 0) {
        formSuccess.value = false;
        formMessage.value = translate("form.document.select.language");
        showModal.value = true;
        return;
    }

    if (types.length === 0) {
        formSuccess.value = false;
        formMessage.value = translate("form.document.select.type");
        showModal.value = true;
        return;
    }
    
    // ✅ VALIDATE EMAIL FORMAT
    const emailField = form.querySelector('input[name="email"]');
    if (emailField && emailField.value) {
      if (!validateEmail(emailField.value)) {
        formSuccess.value = false;
        formMessage.value = translate("form.document.invalid.email");
        showModal.value = true;
        return;
      }
    } 
    // else {
    //   formSuccess.value = false;
    //   formMessage.value = translate("form.document.email.required");
    //   showModal.value = true;
    //   return;
    // }
    
    try {

      const token = await nuxtApp.$recaptcha.execute("submit");
      const form = event.target;
      const formData = new FormData(form);

      formData.append("name", 'Request for Shareholders Meeting Documents');
      formData.append("template", 'request-document');
      formData.append("g-recaptcha-response", token);

      const baseApi = useRuntimeConfig().public.baseApi;

      isLoading.value = true;
      LoadingTitle.value = "Sending ...";
      formSuccess.value = false;

      await useFetch(`${baseApi}/mail/request-document`, {
        method: "POST",
        headers: {
          "X-CSRF-TOKEN": "NUXT",
        },
        body: formData,
      }).then(
        (res) => {
          const data = res.data.value;

          if (data && data.status == "success") {
            formSuccess.value = true;
            formMessage.value = data.data;
            privacyStatement.value = false;
            form.reset()
          } else {
            formSuccess.value = false;
            formMessage.value = data.data;
          }
        },
        (error) => {
          formSuccess.value = false;
          formMessage.value = "error usefetch:" + error;
        }
      );
    } catch (error) {
      formMessage.value = "error catch:" + error;
      formSuccess.value = false;
    }

    showModal.value = true;
    isLoading.value = false;
  };

  const resetModal = () => {
    showModal.value = false; // รีเซ็ตค่า showModal เมื่อ Modal ถูกปิด
  };

  onMounted(() => {
    nuxtApp.$recaptcha.init();
    nuxtApp.$recaptcha.hideBadge = false;

    // Fetch translations
    translationStore.fetchTranslations();
  });

  onBeforeUnmount(() => {
    nuxtApp.$recaptcha.destroy();
  });

  return {
    isLoading,
    LoadingTitle,
    formSuccess,
    formTitle,
    formMessage,
    showModal,
    privacyStatement,
    translate,
    submitForm,
    resetModal,
  };
};